//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { NsIcon } from "@nuskin/design-components";
import { CartService } from "@nuskin/ns-shop";
import { events } from "@nuskin/ns-util";

export default {
  name: "NsMiniCartVue",
  components: {
    NsIcon
  },
  props: {
    count: {
      type: Number,
      default: 0
    }
  },
  data: function() {
    return {
      localCount: 0
    };
  },
  computed: {
    cartCount() {
      return this.localCount || this.count || 0;
    },
    countDisplay() {
      if (this.cartCount < 1) {
        return "";
      } else if (this.cartCount < 100) {
        return this.cartCount;
      } else {
        return 99;
      }
    },
    iconName() {
      if (this.cartCount < 1) {
        return "icon-largecart-empty";
      } else if (this.cartCount < 100) {
        return "icon-largecart-099";
      } else {
        return "icon-largecart-99p";
      }
    }
  },
  mounted: function() {
    this.setupListener();
  },
  methods: {
    setupListener() {
      let that = this;
      events.subscribe(events.shop.CART_UPDATED, info => {
        if (info && info.cartInfo.qty !== undefined) {
          that.localCount = info.cartInfo.qty > 0 ? info.cartInfo.qty : 0;
        }
      });
      events.getValue(events.global.CS_CONFIG_SET, this.configCallback, true);
    },
    /**
     * The mini-cart was clicked
     */
    handleClick() {
      /**
       * Fired when the mini-cart is clicked: function() => void
       *
       * @type {click}
       */
      this.$emit("mini-cart-click");
      CartService.goToCartPage();
    },

    configCallback(configs) {
      if (
        configs &&
        configs.includes("Url") &&
        configs.includes("Loyalty") &&
        configs.includes("Cart")
      ) {
        events.unsubscribe(events.global.CS_CONFIG_SET, this.configCallback);
        this.localCount = CartService.getCartInfo().qty;
      }
    }
  }
};
